<template>
	<div class="search-refund-record">
		<div class="el-search vue-top-padding radius">
			<div class="el-left"></div>
			<div class="el-right">
				<el-form
					ref="refundRecord"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="orderNumber">
						<el-input
							v-model="search.orderNumber"
							:placeholder="$t('searchRefundRecord.orderNumber')"
						></el-input>
					</el-form-item>
					<el-form-item prop="payType">
						<el-select
							v-model="search.payType"
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							clearable
							:placeholder="$t('searchRefundRecord.payType')"
						>
							<el-option
								v-for="item in payTypeList"
								:key="item.id"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('refundRecord')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchRefundRecord",
	props: {
		search: Object,
		payTypeList: Array,
	},
	methods: {
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="scss"></style>
